import Helmet from "../components/Helmet/Helmet";
import CommonSection from "../components/UI/CommonSection";
import {
  Row,
  Container,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardText,
} from "reactstrap";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { logout } from "../Features/userSlice";
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import BookingModal from "./BookingDetails";
import { useState, useEffect } from "react";

import { onLogOut } from "../Features/bookingSlice";
import { deleteBookingDetails } from "../Features/authSlice";
import axiosInstance from "../axiosInstance";
import { constants } from "../Utils/constants";

const navLinks = [
  { path: "edit", display: "Edit Profile" },
  { path: "verifyProfile", display: "Profile Verification" },
  //{ path: "#", display: "Account" },
  { path: "bookings", display: "Bookings" },
];

const ProfLayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.user);

  const [cardData, setCardData] = useState([]);

  const LogOut = (e) => {
    e.preventDefault();
    try {
      dispatch(logout());
      dispatch(onLogOut());
      dispatch(deleteBookingDetails());
      sessionStorage.removeItem("token");
      navigate("/home");
    } catch (err) {}

    // var n = sessionStorage.length;
    // while (n--) {
    //   var key = sessionStorage.key(n);
    //   if (key) {
    //     sessionStorage.removeItem(key);
    //   }
    // }

    //window.location.reload();
  };

  useEffect(() => {
    const allBookingsList = async () => {
      const resp = await axiosInstance.get(constants.serverUrl+`/booking/bookingHistory/${currentUser.id}`
      );
      console.log(resp.data);
      setCardData(resp.data);
    };
    allBookingsList();
  }, []);

  return (
    <>
      <BookingModal cardData={cardData} setCardData={setCardData} />
      <Helmet title="Profile">
        <CommonSection title="Profile" />
        <section>
          <Container>
            <Row className="d-flex justify-content-center">
              <Col lg="3" md="3" className="mb-3">
                <Card
                  className="d-flex justify-content-center text-center"
                  style={{
                    height: "35rem",
                  }}
                >
                  <CardBody>
                    <img
                      className="rounded-circle"
                      width="75px"
                      src="https://st3.depositphotos.com/15648834/17930/v/600/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg"
                    />
                    <CardTitle tag="h5" className="font-weight">
                      {currentUser.firstName}
                    </CardTitle>
                    <CardSubtitle className="mb-2 text-muted" tag="h6">
                      {currentUser.email}
                    </CardSubtitle>
                    <CardText className="">
                      {navLinks.map((item, index) => {
                        if (item.path == "verifyProfile") {
                          return (
                            <Row key={index}>
                              <NavLink
                                to={item.path}
                                className="text-decoration-none mt-3"
                              >
                                <h6 className="fw-bold">
                                  {item.display}{" "}
                                  {/* <span
                                    style={{ height: 10 }}
                                    class="badge bg-danger border border-light rounded-circle"
                                  >
                                    ․
                                  </span> */}
                                </h6>
                              </NavLink>
                            </Row>
                          );
                        } else {
                          return (
                            <Row key={index}>
                              <NavLink
                                to={item.path}
                                className="text-decoration-none mt-3"
                              >
                                <h6 className="fw-bold">{item.display}</h6>
                              </NavLink>
                            </Row>
                          );
                        }
                      })}
                      <Row>
                        <NavLink
                          to={"/home"}
                          className="text-decoration-none mt-3"
                          onClick={LogOut}
                        >
                          <h6 className="fw-bold">LogOut</h6>
                        </NavLink>
                      </Row>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Outlet context={{ cardData }} />
            </Row>
          </Container>
        </section>
      </Helmet>
    </>
  );
};

export default ProfLayout;
